import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Tooltip } from 'react-bootstrap';
import $ from 'jquery';

/* Function */
import ObjGeneral from '../function/';
import ObjAccount from '../function/account';
/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as userProfileActions from '../../actions/user_profile/index';
import * as accountUserActions from '../../actions/account_user/index';

/* Components */
import Header from '../../components/user_profile/header';
import Main from '../../components/user_profile/main';
import ButtonsTop from '../../components/user_profile/buttonsTop';
import ModalPass from '../../components/account_user/modalPass';

import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalPass: false,
      config: {
        id: '',
      }
    }
  }

  async componentDidMount() {
    const userId = localStoreFN().getItem('userId');
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('profile');

    if (userId && permit) {
      if (this.props.setting) {
        this.state.config.id = userId;
        await this.props.actions.fetchUserProfileApi({
          userId: userId
        });
      } else {
        this.props.history.push('/dashboard/authorization');
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  componentWillUnmount() {
    this.props.actions.resetUserProfile();
    this.props.userActions.resetAccountUser();
  }

  handleModalPass = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalPass ? false : true;
      this.setState({ modalPass: reset });
      if (!reset) {
        this.props.userActions.resetModalUser();
        var inputPass = document.getElementById('passup');
        var inputPassRep = document.getElementById('repeat_passup');
        if (inputPass && inputPassRep) {
          inputPass.value = '';
          inputPassRep.value = '';
        }
      }
    }
  };

  handleSubmitEditPass = async event => {
    const id = document.getElementById('idpass').value;
    const pass = document.getElementById('passup').value;
    const repeat_pass = document.getElementById('repeat_passup').value;
    const current_pass = document.getElementById('current_passup').value;

    const obj = {
      id: id,
      user: {
        currentPassword: current_pass,
        newPassword: pass,
        confirmedNewPassword: repeat_pass
      }
    };
    await this.props.userActions.handleUpdateUserPass(obj);
  };

  handleClickConnectFitbit = async event => {
    await this.props.actions.connectFitbit({
      userId: this.state.config.id
    });
  };

  handleClickDisconnectFitbit = async event => {
    await this.props.actions.disconnectFitbit({
      userId: this.state.config.id
    });
    await this.props.actions.fetchUserProfileApi({
      userId: this.state.config.id
    });
  };

  handleClickResetTours = async event => {
    await this.props.actions.resetTours();
  };

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      const setting = ObjGeneral.getSetting({
        setting: {},
        filter: this.props.filter,
        general: obj.generalSetting
      });
      const header = (
        <Header />
      );
      let container = '';
      // condition performed for loading state of the view
      if (this.props.loading
        || this.props.loadingFilter) {
        container = <Loading language={this.props.language} />;
        // the 401 status of the application Expired token or unauthorized
      } else if (
        this.props.status === 401 ||
        this.props.statusTags === 401
      ) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the application success
      } else if (
        this.props.status === 200 &&
        this.props.statusTags === 200
      ) {
        container = (
          <div className={
            "main-container scroll full-height " +
            "user-profile-view " +
            "common-dashboards " +
            "grey"
          }>
            <div className="full-height-container">
              <ButtonsTop
                language={this.props.language ? this.props.language : ''}
                name={this.props.datos.name}
              />
              <Main
                datos={this.props.datos}
                language={this.props.language}
                filter={setting.filter}
                handleModalPass={this.handleModalPass}
                handleClickConnectFitbit={this.handleClickConnectFitbit}
                handleClickDisconnectFitbit={this.handleClickDisconnectFitbit}
                handleClickResetTours={this.handleClickResetTours}
              />
              <ModalPass
                handleModal={this.handleModalPass}
                modal={this.state.modalPass}
                statusSave={this.props.statusSave}
                loadingSave={this.props.loadingSave}
                dataSave={this.props.dataSave}
                config={this.state.config}
                handleSubmit={this.handleSubmitEditPass}
                language={this.props.language ? this.props.language : ''}
              />
              <Tooltip placement="top" id="pageTooltip" />
            </div>
          </div>
        );
      } else if (
        this.props.status === 500 ||
        this.props.statusTags === 500
      ) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section className="main">
          {container}
        </section>
      );
    }

    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}

const mapStateToProps = state => ({
  datos: state.reducer.userProfile.datos,
  loading: state.reducer.userProfile.loading,
  status: state.reducer.userProfile.status,

  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,
  loadingFilter: state.reducer.tags.loading,

  loadingSave: state.reducer.accountUser.loadingSave,
  statusSave: state.reducer.accountUser.statusSave,
  dataSave: state.reducer.accountUser.dataSave,

  setting: state.reducer.dashboard.setting,
  language: state.reducer.dashboard.language,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(userProfileActions, dispatch),
  userActions: bindActionCreators(accountUserActions, dispatch)
});

UserProfile.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserProfile);



// WEBPACK FOOTER //
// ./source/client/containers/user_profile/index.jsx